import { Switch, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(theme => ({
  switch: {
    // to do if required in change in color
  }
}))

export const ToggleSwitch = ({ isChecked, handleChange, disabled, label }) => {
  const classes = useStyles()
  return (
    <>
      <Switch
        checked={isChecked}
        onChange={handleChange}
        color='default'
        disabled={disabled}
        size='small'
        className={classes.switch}
      />
      {label}
    </>
  )
}
